import { LearnLayout } from "./Layout/LearnLayout";

export const MissionLearn = () => {
  return (
    <LearnLayout videoUrl="https://www.loom.com/embed/68cacc7ebb4b42cd8ed38eaff500c015?sid=1251bcc7-caf3-4a9b-93ff-85f6497010bb">
      <h3>Mission</h3>
      <p>
        While your vision statement paints a picture of your desired world, your
        mission statement describes your company's part in making it a reality.
      </p>
      <p>
        The mission is more concrete and less abstract. Its purpose is to
        explain the specific work your team needs to perform to bridge the gap
        between reality today and the future.
      </p>

      <h4>What Is It</h4>
      <p>A clear statement of what your company does to advance your vision.</p>

      <h4>How It Works</h4>
      <p>
        1. Focus on the actions: Make your statement ultra-specific, e.g. "We do
        X" or "Our mission is to provide Y."
      </p>
      <p>
        2. Keep it practical: Detail the practical aspects of your company's
        daily mechanical operations.
      </p>
      <p>
        3. Connect to your vision: Show how your actions advance your reimagined
        world.
      </p>

      <h4>The Result</h4>
      <p>
        A common understanding of your company's mission which shapes everything
        from product decisions, hiring, and strategic goals.
      </p>

      <h4>How Vojomo Helps</h4>
      <p>
        Tell Vo about the actions that your team must take to align with your
        view of the future. You can also check out the video above to learn more
        about creating your company's mission and why it matters.
      </p>
    </LearnLayout>
  );
};
